if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (typeof cartNotification?.setActiveElement === 'function') {
        cartNotification.setActiveElement(this.openedBy);
      }
      this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    ensureStyles(stylesheetLinks) {
      const hrefs = [...new Set(stylesheetLinks.map((link) => (
        new URL(link.getAttribute('href'), window.location.origin).href
      )))];

      return Promise.all(hrefs.map((href) => {
        const existingLink = Array.from(document.querySelectorAll('link[rel="stylesheet"][href]'))
          .find((link) => link.href === href);

        if (existingLink?.sheet) return Promise.resolve();

        return new Promise((resolve) => {
          const link = existingLink || document.createElement('link');
          let timeout;
          const done = () => {
            clearTimeout(timeout);
            resolve();
          };
          link.addEventListener('load', done, { once: true });
          link.addEventListener('error', done, { once: true });
          timeout = setTimeout(done, 8000);

          if (!existingLink) {
            link.rel = 'stylesheet';
            link.href = href;
            document.head.appendChild(link);
          }
        });
      }));
    }

    show(opener) {
      // if (!opener.hasAttribute("data-product-url")){
      //   super.show(opener);
      //   return;
      // };

      const modalOpener = opener.closest('.quick-add');
      if (modalOpener) modalOpener.classList.add('quick-add--visible');
      opener.classList.add('btn--loading');
      opener.setAttribute('aria-disabled', true);
      opener.setAttribute('disabled', true);

      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then(async (responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          const quickBuyContent = responseHTML.getElementById("quick-buy-content").content;
          Array.from(quickBuyContent.querySelectorAll("noscript")).forEach((noScript) => noScript.remove());
          const slickStyles = Array.from(quickBuyContent.querySelectorAll('link[rel="stylesheet"][href]'))
            .filter((link) => /\/slick(?:-theme)?\.css(?:[?#]|$)/.test(link.href));
          await this.ensureStyles(slickStyles);
          slickStyles.forEach((link) => link.remove());
          this.modalContent.replaceChildren(quickBuyContent);
          // opener.removeAttribute('data-product-url');

          const imgsElm = this.modalContent.querySelectorAll('img');

          imgsElm.forEach((imgElm) => {
            imgElm.onload = () => {
              imgElm.classList.add('loaded');
            }
          });

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();
          setTimeout(() => {
            super.show(opener);
          });
        })
        .finally(() => {
          if (modalOpener) modalOpener.classList.remove('quick-add--visible');
          opener.removeAttribute('aria-disabled');
          opener.removeAttribute('disabled');
          opener.classList.remove('btn--loading');
        });
    }
  });
}
